{
  "steps": {
    "reopen": "Appuyez à nouveau sur le lien d'invitation dans le courriel",
    "signIn": "Ouvrez une session avec votre courriel pour rejoindre l'équipe"
  }
}
